"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendEmailPlugin = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const user_ui_1 = require("@sierralabs/user-ui");
const useWorkflowFileUploader_1 = require("../../hooks/useWorkflowFileUploader");
const StyledConfiguratorDiv = styled_components_1.default.div `
  .field {
    margin-top: 12px;
    margin-bottom: 12px;
  }
  .MuiTableCell-root {
    padding: 12px 5px 12px 5px;
  }
`;
const SendEmailConfigurator = props => {
    const { onChange } = props;
    const [invoke, setInvoke] = (0, react_1.useState)(props.invoke);
    const { uploader, proxyOptions } = (0, useWorkflowFileUploader_1.useWorkflowFileUploader)();
    if (!invoke.data)
        invoke.data = {};
    const data = invoke.data;
    const update = (data) => {
        const updatedInvoke = Object.assign(Object.assign({}, invoke), { data });
        setInvoke(updatedInvoke);
        onChange === null || onChange === void 0 ? void 0 : onChange(updatedInvoke);
    };
    return (react_1.default.createElement(StyledConfiguratorDiv, null,
        react_1.default.createElement(user_ui_1.GroupPicker, { multiple: true, value: data.groupIds, textFieldProps: { size: 'medium', label: 'Select Team(s)' }, onChange: groups => {
                data.groupIds = groups.map(group => group.id);
                update(data);
            } }),
        react_1.default.createElement(user_ui_1.UserPicker, { multiple: true, showEmail: true, value: data.userIds, textFieldProps: { label: 'Select User(s)', placeholder: undefined }, onChange: users => {
                data.userIds = users.map(user => user.id);
                update(data);
            } }),
        react_1.default.createElement(core_1.TextField, { variant: 'outlined', label: 'Specific Email IDs', className: 'field', fullWidth: true, value: data.specificEmailIds, onChange: event => {
                data.specificEmailIds = event.target.value;
                update(data);
            } }),
        react_1.default.createElement(core_1.FormControlLabel, { label: 'Include link to item', control: react_1.default.createElement(core_1.Checkbox, { color: 'primary', checked: data.includeLinkToItem, onChange: (_, checked) => {
                    data.includeLinkToItem = checked;
                    update(data);
                } }) }),
        react_1.default.createElement(core_ui_1.InputHtml, { uploader: uploader, proxyOptions: proxyOptions, value: data.message || '', attachments: data.attachments, helperText: 'Enter Custom Message', onChange: value => {
                data.message = value;
                update(data);
            }, onChangeAttachments: attachments => {
                // remove unused signedUrl
                data.attachments = attachments.map(attachment => {
                    attachment = Object.assign({}, attachment);
                    delete attachment.signedUrl;
                    return attachment;
                });
                update(data);
            } })));
};
const SendEmailDisplay = () => {
    return null;
};
exports.SendEmailPlugin = {
    src: 'sendEmail',
    name: 'Send Email',
    configurator: SendEmailConfigurator,
    display: SendEmailDisplay,
    validate: () => {
        return true;
    },
    service: (state, params) => {
        console.log('sendEmail state', state, params);
        return true;
    }
};
//# sourceMappingURL=SendEmailPlugin.js.map